module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oberkulm-5566378a05bee0af8713a7e576941dad.svg";